export default "هغه څنګه\nولې\nڅومره\nڅنګه"